/**
 * Some backend endpoints return HTTP 200 with a flat field-name -> message
 * map on bean-validation failure (e.g. {"userCount": "User count must be at
 * least 1"}), instead of the usual {status: "ERROR", statusDesc: "..."}
 * shape. Callers that only check response.data.status miss these entirely
 * and the UI silently does nothing. This extracts a human-readable message
 * from that flat shape, returning null when the response looks like a
 * normal (non-error) payload.
 */
export function extractValidationErrorMessage(responseData: any): string | null {
  if (!responseData || typeof responseData !== "object") {
    return null;
  }
  if ("status" in responseData || "order_id" in responseData || "data" in responseData) {
    return null;
  }

  const messages = Object.values(responseData).filter(
    (value) => typeof value === "string"
  ) as string[];

  return messages.length > 0 ? messages.join(", ") : null;
}
